import React, { useEffect, useState } from 'react';
import api from '../../../services/api';
import Receipt from '../../receipt/Receipt';
import { BillStatus } from '../../common/Badges';
import { Notice } from '../../common/Feedback';

/** WhatsApp receipt readiness: sending set up, and the invoice template approved by Meta. */
function useWhatsAppStatus() {
  const [status, setStatus] = useState(null);
  useEffect(() => {
    let alive = true;
    api
      .whatsappStatus()
      .then((s) => alive && setStatus(s))
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);
  return status;
}

function WhatsAppNotice({ status }) {
  if (!status) return null;
  if (!status.configured || !status.storage_configured) {
    return <Notice tone="warn">WhatsApp receipts are not set up on the POS server — Send on WhatsApp only marks the invoice.</Notice>;
  }
  const t = status.template || {};
  if (t.status === 'APPROVED') return null;
  if (t.status === 'PENDING') {
    return (
      <Notice tone="info">
        The WhatsApp invoice template is waiting for Meta&apos;s approval. Until then the PDF is sent as a plain document, which only
        arrives if the customer messaged the salon number in the last 24 hours.
      </Notice>
    );
  }
  return <Notice tone="warn">WhatsApp invoice template: {t.status}{t.error ? ` — ${t.error}` : ''}</Notice>;
}

/** Step 7 — invoice preview; print and WhatsApp are the cart panel actions. */
export default function DeliverStep({ bill }) {
  const inv = bill.invoice || {};
  const wa = useWhatsAppStatus();
  return (
    <div className="dp-step-body">
      <div className="dp-step-head dp-step-head--row">
        <div>
          <h2>Print &amp; WhatsApp</h2>
          <p className="dp-help">Invoice {inv.invoice_number} is ready. Print it or send the PDF on WhatsApp.</p>
        </div>
        <BillStatus status={bill.status} />
      </div>
      <WhatsAppNotice status={wa} />
      <div className="dp-delivery-flags">
        <span className={inv.printed ? 'is-on' : ''}>{inv.printed ? 'Printed' : 'Not printed yet'}</span>
        <span className={inv.whatsapp_sent ? 'is-on' : ''}>{inv.whatsapp_sent ? 'Sent on WhatsApp' : 'Not sent on WhatsApp yet'}</span>
      </div>
      <div className="dp-receipt-frame">
        <Receipt bill={bill} />
      </div>
    </div>
  );
}
